// extracted by mini-css-extract-plugin
export default {"cls1":"MultiFactorChallenge-Dialog_cls1__my1g4","cls2":"MultiFactorChallenge-Dialog_cls2__cSqWP MultiFactorChallenge-Dialog_cls1__my1g4"};